import type { FC, HTMLAttributes } from 'react'

export const PayPayLogo: FC<HTMLAttributes<SVGElement>> = props => (
  <svg
    width="865"
    height="866"
    viewBox="0 0 865 866"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M737.075 0.681641C807.427 0.681641 864.962 58.2143 864.962 128.566V737.476C864.962 807.828 807.427 865.36 737.075 865.36H128.168C57.8139 865.36 0.28125 807.828 0.28125 737.476V271.255L0.587264 121.7C4.24963 54.5519 60.1031 0.681641 128.168 0.681641H737.075Z"
      fill="white"
    />
    <path
      d="M168.609 865.36H128.168C57.8139 865.36 0.28125 807.828 0.28125 737.476V271.255C115.042 259.658 222.022 259.964 315.876 268.968L168.609 865.36ZM688.698 462.322C708.995 379.761 575.769 303.304 362.575 274.46L285.202 596.464C463.907 605.011 666.875 551.14 688.698 462.322ZM737.075 0.681641H128.168C60.1031 0.681641 4.24963 54.5519 0.587264 121.7C510.452 107.355 758.439 284.686 719.525 461.559C684.425 620.729 522.659 681.773 259.868 701.917L220.496 865.513H737.075C807.427 865.513 864.962 807.981 864.962 737.629V128.566C864.962 58.2143 807.427 0.681641 737.075 0.681641Z"
      fill="#FF0033"
    />
  </svg>
)
